import type { SipgateGeraet, SipgateZugang, SipgateZugangErgebnis } from '@nac2s/shared'
import { apiFetch } from './client.js'

/**
 * Einstellungen des Anwenders.
 *
 * Die Gestalt der Antworten steht in `packages/shared` — sie war hier zuvor
 * ein zweites Mal von Hand beschrieben. Zwei Beschreibungen derselben Sache
 * laufen auseinander, und der Bruch fällt erst zur Laufzeit auf
 * (`TECHNOLOGY.md` §5).
 */

export type { SipgateGeraet, SipgateZugang, SipgateZugangErgebnis }

export function ladeSipgateZugang(): Promise<SipgateZugang> {
  return apiFetch<SipgateZugang>('/api/settings/sipgate')
}

export function speichereSipgateZugang(eingabe: {
  tokenId: string
  token: string
}): Promise<SipgateZugangErgebnis> {
  return apiFetch<SipgateZugangErgebnis>('/api/settings/sipgate', {
    method: 'PUT',
    body: JSON.stringify(eingabe),
  })
}

export function ladeSipgateGeraete(): Promise<{ geraete: SipgateGeraet[] }> {
  return apiFetch<{ geraete: SipgateGeraet[] }>('/api/settings/sipgate/geraete')
}

export function waehleSipgateGeraet(deviceId: string): Promise<SipgateZugang> {
  return apiFetch<SipgateZugang>('/api/settings/sipgate/geraet', {
    method: 'PUT',
    body: JSON.stringify({ deviceId }),
  })
}

export function loescheSipgateZugang(): Promise<void> {
  return apiFetch<void>('/api/settings/sipgate', { method: 'DELETE' })
}
